TrelloModel = require 'models/internal/trello-model'
_ = require 'underscore'

# emoji-mart uses number values to map out the skin variations
skinUnifiedMap = {
  1: ''
  2: '1F3FB'
  3: '1F3FC'
  4: '1F3FD'
  5: '1F3FE'
  6: '1F3FF'
}

module.exports = class Reaction extends TrelloModel
  typeName: 'Reaction'

  urlRoot: ->
    "/1/actions/#{ @get('idModel') }/reactions"

  sync: (method, model, options) ->
    options.beforeSend = (xhr, settings) ->
      data = JSON.parse settings.data
      if data.emoji?.unified
        data.unified = data.emoji.unified.toUpperCase()
        data.skinVariation = skinUnifiedMap[data.emoji.skin]

      settings.data = JSON.stringify data

    super

  toJSON: (opts = {}) ->
    data = super

    # concatenate shortname and skin tone into one string
    if opts.makeColons
      skinVarColons = _.invert(skinUnifiedMap)[data.emoji.skinVariation]
      _.extend(data.emoji, {
        colons: ":#{data.emoji.shortName}#{if skinVarColons then '::skin-tone-'+skinVarColons else ''}:",
        skin: skinVarColons
      })

    data



// WEBPACK FOOTER //
// ./app/scripts/models/reaction.coffee